export const LILITH_MIRROR_9_LAYOUT = {
    id: 'lilith-mirror-9',
    family: 'mirror',
    cards: 9,
    description: 'Specchio rituale simmetrico con asse centrale dominante e lettura discensiva/ascesiva.',
    supports_focus_overlay: true,
    variants: [
        {
            id: 'portrait',
            points: [
                { x: 22, y: 18, z: 1 },
                { x: 50, y: 18, z: 1 },
                { x: 78, y: 18, z: 1 },
                { x: 22, y: 46, z: 1 },
                { x: 50, y: 50, z: 3 },
                { x: 78, y: 46, z: 1 },
                { x: 22, y: 76, z: 1 },
                { x: 50, y: 82, z: 1 },
                { x: 78, y: 76, z: 1 },
            ],
        },
        {
            id: 'compact',
            points: [
                { x: 24, y: 20, z: 1 },
                { x: 50, y: 20, z: 1 },
                { x: 76, y: 20, z: 1 },
                { x: 24, y: 48, z: 1 },
                { x: 50, y: 52, z: 3 },
                { x: 76, y: 48, z: 1 },
                { x: 24, y: 78, z: 1 },
                { x: 50, y: 82, z: 1 },
                { x: 76, y: 78, z: 1 },
            ],
        },
    ],
};
//# sourceMappingURL=lilith-mirror-9.js.map